/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const HeaderToggles = {
	$domToggleSearch: $('.js-toggle-search'),
	$domToggleLogin: $('.js-toggle-login'),
	$domHeaderSearch: $('.js-header .js-main-search'),
	$domHeaderLogin: $('.js-header-login'),
	classActive: 'is-active',

	/**
	 * @description Initialize
	 */
	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		this.$domToggleSearch.on('click', this.toggleSearch);
		this.$domToggleLogin.on('click', this.toggleLogin);
	},

	toggleSearch: function() {
		HeaderToggles.$domHeaderSearch.toggleClass(HeaderToggles.classActive);
		HeaderToggles.$domHeaderLogin.removeClass(HeaderToggles.classActive);
	},

	toggleLogin: function() {
		HeaderToggles.$domHeaderLogin.toggleClass(HeaderToggles.classActive);
		HeaderToggles.$domHeaderSearch.removeClass(HeaderToggles.classActive);
	}
};

export default HeaderToggles;
